"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Serializer = void 0;
class Serializer {
}
exports.Serializer = Serializer;
//# sourceMappingURL=Serializer.js.map